import React, { ReactElement } from 'react'
import useStepHook from '../hooks/useStepHook'

function SubmitButton({
  label,
  onClick,
  className,
  disabled,
}: {
  className?: string
  label: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
}): ReactElement {
  const { isLastStep } = useStepHook()
  const btnLabel = isLastStep() ? 'Terminer' : label

  return (
    <button
      data-testid="goToNextStepBtn"
      disabled={disabled}
      className={`btn btnPrimary wFull wAutoSm ${className}`}
      type="submit"
      onClick={onClick}
    >
      {btnLabel}
    </button>
  )
}

export default SubmitButton
